  <template>
    <div>
      <card-layout
        title="Category Projection Details"
      >
        <TotalsProjectionsRadial
            :ie_user="user['ie_user'] === 0 ? false : true"
        ></TotalsProjectionsRadial>
        <TotalsSafeRadial
        ></TotalsSafeRadial>
      </card-layout>
    </div>
</template>

<script setup>
  import { onMounted, computed, ref} from 'vue';
  import { storeToRefs } from 'pinia';
  import CardLayout from '../details/CardLayout.vue'
  import TotalsProjectionsRadial from './TotalsProjectionsRadial.vue';
  import TotalsSafeRadial from './TotalsSafeRadial.vue';

  onMounted(() => {
    // console.log('TotalsProjection Component mounted.');
  });

  //Props
  const props = defineProps({
    user: {required: true, type: Object},
  });
</script>
<style>
</style>